import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TagManagerDirective } from '../../../../directives/tag-manager.directive';

@Component({
    selector: 'app-manutencao-toolbar',
    templateUrl: './manutencao-toolbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TagManagerDirective]
})
export class ManutencaoToolbarComponent {
  @Input() campoInput: string = '';
  @Input() buscaFiltrada: boolean = false;
  @Input() placeholder: string = '';
  @Input() tagBuscar: any;
  @Input() tagLimpar: any;

  @Output() campoInputChange = new EventEmitter<string>();
  @Output() buscar = new EventEmitter<void>();
  @Output() limpar = new EventEmitter<void>();

  onInput(value: string) { this.campoInputChange.emit(value); }
}
